export default "/images/Pro-12a.png?aa99294f8d2d5fbcb2ebe1fe66f734a9";